module.exports = __webpack_public_path__ + "media/images/testing/hire-select-logo-40201e9ae21d377a522321ae6a0a3328.gif";